/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailTemplateType } from './MailTemplateType';
import {
    MailTemplateTypeFromJSON,
    MailTemplateTypeFromJSONTyped,
    MailTemplateTypeToJSON,
    MailTemplateTypeToJSONTyped,
} from './MailTemplateType';

/**
 * 
 * @export
 * @interface MailTemplateEntity
 */
export interface MailTemplateEntity {
    /**
     * メールテンプレート種別
     * @type {MailTemplateType}
     * @memberof MailTemplateEntity
     */
    type: MailTemplateType;
    /**
     * 件名
     * @type {string}
     * @memberof MailTemplateEntity
     */
    subject: string;
    /**
     * プレーンテキスト本文
     * @type {string}
     * @memberof MailTemplateEntity
     */
    bodyText: string;
    /**
     * テナント保存済みのカスタムテンプレートかどうか
     * @type {boolean}
     * @memberof MailTemplateEntity
     */
    isCustomized: boolean;
    /**
     * デフォルトの件名（カスタマイズ中でも参照できるよう常に返す）
     * @type {string}
     * @memberof MailTemplateEntity
     */
    defaultSubject: string;
    /**
     * デフォルトのプレーンテキスト本文（カスタマイズ中でも参照できるよう常に返す）
     * @type {string}
     * @memberof MailTemplateEntity
     */
    defaultBodyText: string;
}



/**
 * Check if a given object implements the MailTemplateEntity interface.
 */
export function instanceOfMailTemplateEntity(value: object): value is MailTemplateEntity {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('bodyText' in value) || value['bodyText'] === undefined) return false;
    if (!('isCustomized' in value) || value['isCustomized'] === undefined) return false;
    if (!('defaultSubject' in value) || value['defaultSubject'] === undefined) return false;
    if (!('defaultBodyText' in value) || value['defaultBodyText'] === undefined) return false;
    return true;
}

export function MailTemplateEntityFromJSON(json: any): MailTemplateEntity {
    return MailTemplateEntityFromJSONTyped(json, false);
}

export function MailTemplateEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailTemplateEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'type': MailTemplateTypeFromJSON(json['type']),
        'subject': json['subject'],
        'bodyText': json['bodyText'],
        'isCustomized': json['isCustomized'],
        'defaultSubject': json['defaultSubject'],
        'defaultBodyText': json['defaultBodyText'],
    };
}

export function MailTemplateEntityToJSON(json: any): MailTemplateEntity {
    return MailTemplateEntityToJSONTyped(json, false);
}

export function MailTemplateEntityToJSONTyped(value?: MailTemplateEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': MailTemplateTypeToJSON(value['type']),
        'subject': value['subject'],
        'bodyText': value['bodyText'],
        'isCustomized': value['isCustomized'],
        'defaultSubject': value['defaultSubject'],
        'defaultBodyText': value['defaultBodyText'],
    };
}

